<template>
    <div>
       <h3 v-if="!isFM && !isCarpetLine" class="text-themecolor">{{$t('homepage.welkombijbesimple')}} </h3>
       <h3 v-if="isFM" class="text-themecolor">{{$t('homepage.welkombijfmmodule')}} </h3>
       <h3 v-if="isCarpetLine" class="text-themecolor">{{$t('homepage.welkombijcarpetline')}} </h3>
    </div>
</template>
<script>
import { productInfo } from '@/mixins/productInfo'

export default {
    mixins: [productInfo],
    computed: {
        isFM() {
            return this.isFMModule()
        },
        isCarpetLine() {
            return this.isCarpetline()
        }
    }
}
</script>